<div class="comparisonPage scrollPage templatePage" *ngIf="isReadyToShow">

    <div class="alert alert-warning" role="alert" *ngIf="filteredRouleaux.length === 0">
        {{ 'comparisonPage.notItem' | translate }}
    </div>

    <div class="row mr-0 ml-0" *ngIf="filteredRouleaux.length > 0">
        <div class="col-sm-6 col-md-3 border text-center btn font-weight-bold"
             [ngClass]="{'btn-lemken': isFilterBySol, 'btn-outline-lemken': !isFilterBySol}"
             (click)="isFilterBySol = true">
            {{ 'comparisonPage.filterBySol' | translate}}
        </div>
        <div class="col-sm-6 col-md-3  border text-center btn font-weight-bold"
             [ngClass]="{'btn-lemken': !isFilterBySol, 'btn-outline-lemken': isFilterBySol}"
             (click)="isFilterBySol = false">
            {{ 'comparisonPage.filterByUtilisation' | translate}}
        </div>
        <div class="col-sm-12 col-md-6 form-check-inline mr-0">
            <select class="form-control"
                    [(ngModel)]="selectedRouleau"
                    name="inputRouleau"
                    id="inputRouleau">
                <option [ngValue]="null" disabled selected
                        hidden>{{'comparisonPage.toChooseRouleau' | translate}}</option>
                <option [ngValue]="rouleau"
                        *ngFor="let rouleau of notFilteredRouleaux">
                    {{ rouleau.description.nom}}
                </option>
            </select>
            <button class="btn btn-lemken" (click)="addSelection()" [disabled]="selectedRouleau == null">
                <fa-icon icon="plus" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
            <button class="btn btn-lemken" *ngIf="isEdit" (click)="changeSelection()"
                    [disabled]="selectedRouleau == null">
                <fa-icon icon="pencil-alt" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
        </div>


    </div>


    <div class="table-responsive" *ngIf="filteredRouleaux.length > 0">
        <table class="table table-borderless">
            <thead>
            <tr>
                <th scope="col" class="text-center text-lemken border-right border-lemken"
                    *ngFor="let rouleau of filteredRouleaux; index as i">
                    {{rouleau.description.nom}}<br/>
                    {{rouleau.rouleau.famille}}<br/>
                    <!--
                    <span>
                        <fa-icon icon="pencil-alt" [fixedWidth]="true" (click)="editSelection(i)"></fa-icon>
                    </span>
                    &nbsp;&nbsp;
                    -->
                    <span>
                        <fa-icon icon="times" [fixedWidth]="true" (click)="removeSelection(rouleau, i)"></fa-icon>
                    </span>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [colSpan]="filteredRouleaux.length"
                    class="bg-lemken text-center text-white">{{'comparisonPage.largeur' | translate}}</td>
            </tr>
            <tr>
                <td class="text-center text-lemken border-right border-lemken"
                    *ngFor="let rouleau of filteredRouleaux">{{rouleau.rouleau.diametreRouleau}}</td>
            </tr>

            <ng-template ngFor let-category [ngForOf]="viewSolTab" *ngIf="isFilterBySol">
                <tr>
                    <td [colSpan]="filteredRouleaux.length" class="bg-primary text-center text-white"
                        (click)="category.selected = !category.selected">
                        {{'comparisonPage.' + category.category | translate}}
                        <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!category.selected"></fa-icon>
                        <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="category.selected"></fa-icon>
                    </td>
                </tr>
                <ng-template ngFor let-item [ngForOf]="category.tab" *ngIf="category.selected">
                    <tr>
                        <td [colSpan]="filteredRouleaux.length" class="bg-lemken text-center text-white">
                            {{'comparisonPage.' + item.typeSol | translate}}
                            / {{'comparisonPage.' + item.utilisation | translate}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center text-lemken border-right border-lemken"
                            *ngFor="let rouleau of filteredRouleaux">
                            <mo-lemken-note [note]="getRouleauNoteProperty(rouleau.note, item.key)"></mo-lemken-note>
                        </td>
                    </tr>
                </ng-template>
            </ng-template>

            <ng-template ngFor let-category [ngForOf]="viewUtilisationTab" *ngIf="!isFilterBySol">
                <tr>
                    <td [colSpan]="filteredRouleaux.length" class="bg-primary text-center text-white"
                        (click)="category.selected = !category.selected">
                        {{'comparisonPage.' + category.category | translate}}
                        <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!category.selected"></fa-icon>
                        <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="category.selected"></fa-icon>
                    </td>
                </tr>
                <ng-template ngFor let-item [ngForOf]="category.tab" *ngIf="category.selected">
                    <tr>
                        <td [colSpan]="filteredRouleaux.length" class="bg-lemken text-center text-white">
                            {{'comparisonPage.' + item.typeSol | translate}}
                            / {{'comparisonPage.' + item.utilisation | translate}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center text-lemken border-right border-lemken"
                            *ngFor="let rouleau of filteredRouleaux">
                            <ng-container [ngSwitch]="getRouleauNoteProperty(rouleau.note, item.key)">
                                <span *ngSwitchCase="0">
                                    <img src="assets/images/smiley-0.png" Class="smileyNote" alt="0"/>
                                </span>
                                <span *ngSwitchCase="1">
                                    <img src="assets/images/smiley-1.png" Class="smileyNote" alt="1"/>
                                </span>
                                <span *ngSwitchCase="2">
                                    <img src="assets/images/smiley-1.png" Class="smileyNote" alt="1"/>
                                    <img src="assets/images/smiley-1.png" Class="smileyNote" alt="1"/>
                                </span>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </ng-template>

            </tbody>
        </table>
    </div>
</div>

<footer class="fixed-bottom">
    <app-data-validity-mention></app-data-validity-mention>
</footer>
